import { type FC } from 'react';
import AppCard from './AppCard';
import { UiIconBroadcast } from '@/lib/ui';

export interface WebinarCardProps {
  isSelected?: boolean
  navLink?: string
  isEnabled?: boolean
}

const WebinarCard: FC<WebinarCardProps> = ({
  isSelected = false,
  navLink = '',
  isEnabled = false
}) => {
  return (
    <AppCard
      icon={(<UiIconBroadcast size={'3xl'} color={isEnabled ? 'green.500' : 'gray.800'} />)}
      name={'Webinar'}
      description={'Manage your own webinars.'}
      isSelected={isSelected}
      navLink={navLink}
    />
  );
};
export default WebinarCard;
